import { InspireEffect } from 'game/extended/creatures/goblins/abilities/inspire/inspire_effect'

export default {
    events: {},
    effects: { InspireEffect },
}